import { X } from 'lucide-react';
import { getErrorMessage } from '@/lib/error-message';
import { cn } from '@/lib/utils';
import { fieldErrorMessageClassName } from './field-error';

export function FormError({ error, onDismiss }: { error: unknown; onDismiss: () => void }) {
  if (!error) return null;
  return (
    <div role="alert" className={cn('flex items-start gap-2', fieldErrorMessageClassName)}>
      <p className="min-w-0 flex-1">{getErrorMessage(error)}</p>
      <button
        type="button"
        aria-label="Fechar mensagem de erro"
        onClick={onDismiss}
        className="shrink-0 rounded-sm hover:bg-red-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-current"
      >
        <X className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
}
